import { postRequest } from '../helpers/utilities';
import { postCardAnimations } from '../animations/postCard';

const newsfeedFunctions = () => {
	const filterIds = [];

	const filters = document.querySelectorAll('.js-newsfeed-filter-trigger');

	if (filters) {
		filters.forEach(filter => {
			filter.addEventListener('click', e => {
				e.preventDefault();

				const categroyId = filter.dataset.filter;
				const itemsContainer = filter.closest('.newsfeed-grid').querySelector('.js-newsfeed-items');

				if (filter.classList.contains('active')) {
					// Remove category id from filter ids
					filterIds.splice(filterIds.indexOf(categroyId), 1);
				} else {
					// Add category id to filter ids
					filterIds.push(categroyId);
				}

				// Toggle active class on clicked filter
				filter.classList.toggle('active');

				// Filter posts
				filterPosts(filterIds, 'filter', itemsContainer);
			});
		});
	}

	const loadMoreBtns = document.querySelectorAll('.js-newsfeed-load-more');

	if (loadMoreBtns) {
		loadMoreBtns.forEach(btn => {
			btn.addEventListener('click', async () => {
				const itemsContainer = btn.closest('.newsfeed-grid').querySelector('.js-newsfeed-items');

				filterPosts(filterIds, 'loadMore', itemsContainer);
			});
		});
	}
};

const filterPosts = async (filterIds = [], type, itemsContainer) => {
	itemsContainer.classList.add('loading');

	const loadMoreBtn = itemsContainer.closest('.newsfeed-grid').querySelector('.js-newsfeed-load-more');

	if (type === 'loadMore' && loadMoreBtn) {
		// Add loading state to button
		loadMoreBtn.classList.add('opacity-50', 'pointer-events-none');
		loadMoreBtn.querySelector('span').textContent = 'Loading...';
	}

	const offset = type === 'loadMore' ? itemsContainer.querySelectorAll('.js-newsfeed-item').length : 0;
	let ppp = itemsContainer.dataset.ppp ? parseInt(itemsContainer.dataset.ppp) : 12;

	// Fetch the posts
	try {
		// Get the fetch data
		const getFetchData = () => {
			const formData = new FormData();

			formData.append('action', 'get_newsfeed_items_ajax');
			formData.append('ppp', ppp);
			formData.append('offset', offset);

			if (filterIds.length > 0) {
				formData.append('filterIds', filterIds);
			}

			const ajaxData = new URLSearchParams(formData);

			return ajaxData;
		};

		const fetchData = getFetchData();

		// Fetch the posts
		const data = await postRequest(fetchData);

		// Check if the posts are fetched successfully
		if (data.success && data.posts) {
			setTimeout(() => {
				if (type === 'loadMore') {
					// Add new posts to the container
					itemsContainer.innerHTML += data.posts;

					// Reset button
					if (loadMoreBtn) {
						loadMoreBtn.classList.remove('opacity-50', 'pointer-events-none');
						loadMoreBtn.querySelector('span').textContent = 'View More';
					}
				} else {
					// Update the container with the new posts
					itemsContainer.innerHTML = data.posts;
				}

				// Hide button if all items are loaded
				if (loadMoreBtn) {
					if (itemsContainer.querySelectorAll('.js-newsfeed-item').length >= data.totalItemsCount) {
						loadMoreBtn.classList.add('!hidden');
					} else {
						loadMoreBtn.classList.remove('!hidden');
					}
				}

				// Initialize post card animations
				postCardAnimations();

				// Remove loading state
				itemsContainer.classList.remove('loading');
			}, 400);
		} else {
			// Show error message
			alert('An error occurred while fetching the posts. Please try again later.');
		}
	} catch (error) {
		// Show error message
		alert('An error occurred while fetching the posts. Please try again later.');
		console.error(error);
	}
};

newsfeedFunctions();
